import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderDateComponent } from "../smart-table-customs/custom-render-date";
import { StbCustomRenderCheckboxComponent } from "../smart-table-customs/custom-render-checkbox";
import { FormBuilder } from "@angular/forms";

import { Person } from "../../models/person.model";
import Shop from "../../models/shop.model";
import { Customer } from "../../models/customer.model";
import { Supplier } from "../../models/supplier.model";
import { Employee } from "../../models/employee.model";
import { DialogWorkingTaskComponent } from "../dialog-working-task/dialog-working-task.component";
import WorkingTask from "../../models/working-task.model";
import { StbCustomRenderStatusComponent } from "../smart-table-customs/custom-render-status";
import { PRIORITIES, STATUS } from "../../@core/data/default-list";
import { StbCustomRenderPriorityComponent } from "../smart-table-customs/custom-render-priority";
import { Project } from "../../models/project.model";
import { StbCustomRenderObjectComponent } from "../smart-table-customs/custom-render-object";
import { StbCustomRenderProcessorComponent } from "../smart-table-customs/custom-render-processor";

@Component({
  selector: "ngx-view-table-workings",
  styleUrls: ["./view-table-workings.component.scss"],
  templateUrl: "./view-table-workings.component.html",
})
export class ViewTableWorkingsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = ""; //yesterday/planing/incomplete/complete/cancel
  @Input() shopId?: string = "";
  @Input() shop?: Shop;

  @Input() users?: Person[];
  @Input() customers?: Customer[];
  @Input() employees?: Employee[];
  @Input() suppliers?: Supplier[];
  @Input() persons?: Person[];
  @Input() projects?: Project[];
  @Input() source: LocalDataSource = new LocalDataSource();
  @Input() workingTasks?: WorkingTask[] = [];

  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";
  user: User;

  issueDate: Date = new Date();
  statusList = STATUS;
  priorities = PRIORITIES;

  //ng2-smart-table config
  settings = {};
  perPage = "10";

  constructor(
    private userService: UserService,
    private dialogService: NbDialogService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          this.settings = {
            hideHeader: false,
            noDataMessage: "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            pager: {
              perPage: this.perPage,
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              issueDate: {
                title: "Ngày thực hiện",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              dueDate: {
                title: "Hạn hoàn thành",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              projectName: {
                title: "Dự án",
                type: "string",
                filter: false,
              },
              objectType: {
                title: "Đối tượng",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderObjectComponent,
              },
              title: {
                title: "Công việc",
                type: "string",
              },
              priority: {
                title: "Mức độ",
                type: "custom",
                renderComponent: StbCustomRenderPriorityComponent,
                filter: {
                  type: "list",
                  config: {
                    selectText: "Chọn tất cả",
                    list: this.priorities,
                  },
                },
              },
              strProcessors: {
                title: "Người thực hiện",
                type: "custom",
                renderComponent: StbCustomRenderProcessorComponent,
              },
              assignName: {
                title: "Người giám sát",
                type: "string",
              },
              isFinished: {
                title: "Hoàn thành?",
                type: "custom",
                renderComponent: StbCustomRenderCheckboxComponent,
                filter: {
                  type: "checkbox",
                  config: {
                    true: "true",
                    false: "false",
                    resetText: "Xóa",
                  },
                },
              },
              status: {
                title: "Trạng thái",
                type: "custom",
                renderComponent: StbCustomRenderStatusComponent,
                filter: {
                  type: "list",
                  config: {
                    selectText: "Chọn tất cả",
                    list: this.statusList,
                  },
                },
              },
            },
          };
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changePerPage() {
    this.source.getPaging().perPage = this.perPage;
    this.source.setPage(1);
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);

    let itemEdited = _.clone(item);
    this.dialogService
      .open(DialogWorkingTaskComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          header: itemEdited.title,
          mode: "edit",
          task: itemEdited,
          customers: this.customers,
          suppliers: this.suppliers,
          employees: this.employees,
          projects: this.projects,
          users: this.users,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          itemEdited = item;
        }
      });
  }
}
